// 🖍️ 22/10/2026: a página da folha de colorir da Lulu e do Nando (/colorir), pedido do Jerônimo aprovado pelo dono.
// É o "link na bio" do Instagram e dos stories da JoinKids Streaming. Aqui ficam os endereços e a contagem.
//
// A folha fica numa pasta PÚBLICA do site (public/colorir): baixa sem login, sem cadastro e sem e-mail.
//
// Contagem (para saber se funcionou): a página avisa o NOSSO servidor quando aparece na tela e quando alguém toca nos
// botões, pedindo o arquivo /colorir/contar.txt com o que aconteceu no endereço (evento e origem). O registro normal
// do servidor (nginx) guarda o pedido, e o programa contar_colorir.py soma por dia. Sem cookie, sem conta e sem
// serviço de fora. A visita só conta quando a página aparece de verdade na tela (o Instagram às vezes carrega a
// página antes do toque), uma vez por aba; os robôs ficam de fora no programa que soma.

export const FOLHA_PDF = '/colorir/folha-de-colorir-lulu-e-nando.pdf';
export const FOLHA_NOME = 'folha-de-colorir-lulu-e-nando.pdf';
export const FOLHA_IMAGEM = '/colorir/folha-de-colorir-lulu-e-nando.webp';
export const CONTADOR = '/colorir/contar.txt';
export const STONELBOX = 'https://stonelbox.joinkids.com.br/?utm_source=joinkids&utm_campaign=colorir';

const lerParametro = (busca, nome) => {
    try { return new URLSearchParams(busca || '').get(nome) || ''; } catch (e) { return ''; }
};

// De onde a pessoa veio: o utm_source do link (o da bio vai com utm_source=instagram). Só letras, números e hífen,
// até 20 caracteres. Sem marca: "sem".
export const origemDaVisita = (busca = '') =>
    lerParametro(busca, 'utm_source').trim().toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 20) || 'sem';

// Quem chegou ao Chrome ou ao Safari pela dica do Instagram traz a marca "veio" (utils/navegadorApp).
export const veioPelaDica = (busca = '') => {
    const veio = lerParametro(busca, 'veio');
    return veio === 'instagram' || veio === 'facebook' ? veio : '';
};

export const enderecoDaContagem = (evento, origem, veio = '') =>
    `${CONTADOR}?evento=${encodeURIComponent(evento)}&origem=${encodeURIComponent(origem)}` +
    (veio ? `&veio=${encodeURIComponent(veio)}` : '');

// Manda o aviso sem atrapalhar nada: nunca dá erro na tela, e o "keepalive" deixa o aviso seguir mesmo quando o
// toque leva a pessoa para outra página.
export const contar = (evento, origem, veio = '') => {
    try {
        if (typeof fetch !== 'function') return;
        const pedido = fetch(enderecoDaContagem(evento, origem, veio),
            { method: 'GET', keepalive: true, cache: 'no-store', credentials: 'omit' });
        if (pedido && typeof pedido.catch === 'function') pedido.catch(() => { });
    } catch (e) { }
};

// A visita conta uma vez por aba.
const CHAVE_VISITA = 'JoinKids::colorir:visita';
export const contarVisitaUmaVez = (origem, veio = '') => {
    try {
        if (window.sessionStorage.getItem(CHAVE_VISITA)) return false;
        window.sessionStorage.setItem(CHAVE_VISITA, '1');
    } catch (e) { }
    contar('visita', origem, veio);
    return true;
};
